function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCurrentUser } from "@sprout/client-graphql";
import { Button as BaseButton } from "sprout-ui-dom";
import { useBus } from "sprout-ui-dom/dist/Bus";
import getFullName from "@sprout/client-lib/dist/getFullName";
import { forwardRef, useCallback } from "react";
import { useUserCard_SetUserFollowMutation } from "sprout-graphql";
import { useSnackbar } from "sprout-ui-dom/dist/Snackbar";
import { Text, Flex, Box } from "sprout-ui-primitives";
import styled from "styled-components";
import Avatar from "../Avatar";
import { Card, CardLink, CardContent } from "../Card";
const Button = styled(BaseButton)`
  flex: none;
`;
const UserCard = /*#__PURE__*/ forwardRef(function UserCardForwardRef(props, ref4) {
    const { user , navigationItemHelpers  } = props, rest = _objectWithoutProperties(props, [
        "user",
        "navigationItemHelpers"
    ]);
    const { username , amFollowing  } = user;
    const currentUser = useCurrentUser();
    const isCurrentUser = currentUser && currentUser.id === user.id;
    const eventBus = useBus();
    const showSnackbar = useSnackbar();
    const [setUserFollowMutation] = useUserCard_SetUserFollowMutation();
    const handleUndo = useCallback(()=>{
        setUserFollowMutation({
            variables: {
                userId: user.id,
                // NOTE: Refer #97 on GitHub
                ignore: !user.amFollowing,
                topicIgnore: !user.amFollowing,
                deep: true
            }
        }).then(()=>{
            showSnackbar({
                message: `You ${user.amFollowing ? "followed" : "unfollowed"} @${user.username} and all their trees`
            });
        });
    }, [
        setUserFollowMutation,
        showSnackbar,
        user.amFollowing,
        user.id,
        user.username, 
    ]);
    const handleClick = useCallback((event)=>{
        event.stopPropagation();
        if (!currentUser || !currentUser.active) {
            eventBus.emit("dialog::auth::open");
            return;
        }
        setUserFollowMutation({
            variables: {
                userId: user.id,
                ignore: user.amFollowing ? null : false,
                topicIgnore: !user.amFollowing,
                deep: false
            }
        }).then((result)=>{
            var ref, ref1, ref2, ref3;
            const topicFollowsByUserId = (ref = result.data) === null || ref === void 0 ? void 0 : (ref1 = ref.setUserFollow) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.query) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.currentUser) === null || ref3 === void 0 ? void 0 : ref3.topicFollowsByUserId;
            // TODO: Might be better if GraphQL can filter this result based on
            // user.id so that we don't have to return the whole list, as the list
            // might grow indifinitely in the future.
            const titles = ((topicFollowsByUserId === null || topicFollowsByUserId === void 0 ? void 0 : topicFollowsByUserId.edges) || []).filter(({ node: { itemByTopicId: topic  }  })=>{
                return (topic === null || topic === void 0 ? void 0 : topic.userId) === user.id;
            }).map(({ node: { itemByTopicId: topic  }  })=>{
                return (topic === null || topic === void 0 ? void 0 : topic.title) || "No title";
            });
            showSnackbar({
                message: titles.length === 0 ? `You ${user.amFollowing ? "unfollowed" : "followed"} @${user.username}` : `You ${user.amFollowing ? "unfollowed" : "followed"} @${user.username}, but are ${!user.amFollowing ? "not following" : "still following"} ${titles.reduce((a, b, i)=>`${a}${i + 1 === titles.length ? " and" : ","} ${b}`, "")}`,
                actionText: titles.length === 0 ? undefined : user.amFollowing ? "UNFOLLOW ALL" : "FOLLOW ALL",
                onAction: handleUndo
            });
        });
    }, [
        currentUser,
        eventBus,
        handleUndo,
        setUserFollowMutation,
        showSnackbar,
        user.amFollowing,
        user.id,
        user.username, 
    ]);
    return /*#__PURE__*/ _jsxs(Card, _objectSpread({
        isActive: navigationItemHelpers === null || navigationItemHelpers === void 0 ? void 0 : navigationItemHelpers.isActive
    }, rest, {
        ref: ref4,
        children: [
            /*#__PURE__*/ _jsx(CardLink, {
                to: `/${user.username}`
            }),
            /*#__PURE__*/ _jsxs(CardContent, {
                as: Flex,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ _jsx(Box, {
                        flex: "none",
                        children: /*#__PURE__*/ _jsx(Avatar, {
                            user: user,
                            size: 64,
                            navigable: true
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Flex, {
                        flex: "1",
                        minWidth: "0",
                        flexDirection: "column",
                        justifyContent: "center",
                        ml: 3,
                        mr: 1,
                        children: [
                            /*#__PURE__*/ _jsx(Text, {
                                truncate: true,
                                fontSize: "18px",
                                color: "black.87",
                                fontWeight: "bold",
                                children: username
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                truncate: true,
                                fontSize: 1,
                                color: "black.60",
                                mt: "2px",
                                children: getFullName(user)
                            })
                        ]
                    }),
                    !isCurrentUser && /*#__PURE__*/ _jsx(Button, {
                        variant: user.amFollowing ? "bright-teal" : "bright-blue",
                        onClick: handleClick,
                        children: amFollowing ? "Following" : "Follow"
                    })
                ]
            })
        ]
    }));
});
export default UserCard;
